/* TrueMed facade (#89 ph2, #93): static entry rendered by the snippet; the
   s3 script loads on interaction only (hover prefetch / click). The widget
   APPENDS its entry beside non-empty containers, so the facade removes itself
   when the real .truemed-entry-box renders. Script blocked = line stays as
   plain information. */

let injected = null;

function loadScript(src) {
  if (injected) return injected;
  injected = new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = src;
    s.onload = resolve;
    s.onerror = () => {
      injected = null; /* retry on next interaction */
      reject(new Error('truemed failed'));
    };
    document.head.append(s);
  });
  return injected;
}

class TruemedFacade extends HTMLElement {
  connectedCallback() {
    const src = this.dataset.scriptSrc;
    if (!src) return;
    const dropFacade = () => {
      /* facade uses tm-facade-box; .truemed-entry-box is the widget's */
      if (this.querySelector('.truemed-entry-box')) {
        this.querySelector('[data-tm-facade]')?.remove();
        observer.disconnect();
      }
    };
    const observer = new MutationObserver(dropFacade);
    observer.observe(this, { childList: true, subtree: true });
    dropFacade();
    this.addEventListener('pointerenter', () => loadScript(src).catch(() => {}), { once: true });
    this.addEventListener('click', async (event) => {
      if (!this.querySelector('[data-tm-facade]')) return; /* widget owns clicks now */
      if (!event.target.closest('[data-tm-open]')) return;
      event.preventDefault();
      try {
        await loadScript(src);
        for (let i = 0; i < 40; i++) {
          const real = this.querySelector('.truemed-instructions-open');
          if (real) return real.click();
          await new Promise((r) => setTimeout(r, 125));
        }
      } catch {
        /* leave the static line */
      }
    });
  }
}

if (!customElements.get('truemed-facade')) {
  customElements.define('truemed-facade', TruemedFacade);
}
